import { api } from '@/config/api'

const schoolGroupBaseEndpoint = '/SchoolGroupApi'

export const saveSchoolGroupInfo = schoolGroupInfo =>
  api.put(`${schoolGroupBaseEndpoint}/${schoolGroupInfo.id}`, schoolGroupInfo)

export const getAllSchoolsInSchoolGroup = (schoolGroupId) =>
  api.get(`${schoolGroupBaseEndpoint}/${schoolGroupId}/AssociatedSchools`)

export const getSchoolsWithCourses = (schoolGroupId) =>
  api.get(`${schoolGroupBaseEndpoint}/${schoolGroupId}/SchoolsWithCourses`)
